import AutomationNavigation from './AutomationNavigation';

export default AutomationNavigation;
